import { render, staticRenderFns } from "./FormRatingState.vue?vue&type=template&id=596f4086&"
import script from "./FormRatingState.vue?vue&type=script&lang=js&"
export * from "./FormRatingState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports